export var CreateSubscriptionError;
(function (CreateSubscriptionError) {
})(CreateSubscriptionError || (CreateSubscriptionError = {}));
var CreateSubscriptionRequest = /** @class */ (function () {
    function CreateSubscriptionRequest(tags) {
        this.knownErrorCodes = Object.values(CreateSubscriptionError);
        this.method = 'post';
        this.path = 'my/info-card-subscriptions';
        var channels = ['email'];
        this.body = JSON.stringify({ tags: tags, channels: channels });
    }
    return CreateSubscriptionRequest;
}());
export { CreateSubscriptionRequest };
